module.exports = __webpack_public_path__ + "static/media/PLANTA.4df7fa02.png";